var map = {
	"./BOU/kit.png": "fbd0",
	"./DRU/kit.png": "9257",
	"./FNB/kit.png": "fc7c",
	"./HIM/kit.png": "10bd",
	"./OTH/kit.png": "b759",
	"./SUP/kit.png": "4d2e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7dfe";